import { render, staticRenderFns } from "./edit-log.vue?vue&type=template&id=405b3503&"
import script from "./edit-log.vue?vue&type=script&lang=ts&"
export * from "./edit-log.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports